// extracted by mini-css-extract-plugin
export default {"headercard":"HeaderCard_headercard__hfmh4","textarea":"HeaderCard_textarea__gYQFK","highlight":"HeaderCard_highlight__XzA1q"};